import TransformIcon from "@mui/icons-material/Transform";

export const PanToolConfig = {
  name: "PAN",
  tool: "Pan",
  icon: <TransformIcon />,
};